module.exports = __webpack_public_path__ + "0b755f764d7ed9253fd9474e8c05e0ef.svg";